module.exports = __webpack_public_path__ + "static/img/Panthers.54f35e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Panthers.svg
// module id = wOb3
// module chunks = 0